import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  Cell,
} from "recharts";

const UserGraph = ({ allusers }) => {
  const batchCounts = {};
  allusers.forEach((u) => {
    const batch = u.batch?.trim() || "Unknown";
    batchCounts[batch] = (batchCounts[batch] || 0) + 1;
  });

  const barData = Object.entries(batchCounts)
    .map(([batch, count]) => ({ name: batch, count }))
    .sort((a, b) => b.count - a.count);

  const COLORS = ["#0088FE", "#00C49F", "#FFBB28", "#FF8042", "#FF6347", "#A020F0", "#20B2AA", "#FF1493", "#8B4513", "#6A5ACD"];

  const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload.length) {
      const { name, count } = payload[0].payload;
      return (
        <div className="bg-white border border-gray-300 rounded px-3 py-2 shadow">
          <span className="font-semibold">{name}:</span> {count} users
        </div>
      );
    }
    return null;
  };

  return (
    <div className="mb-6">
      {barData.length === 0 ? (
        <p className="text-center text-gray-500">No users found.</p>
      ) : (
        <ResponsiveContainer width="100%" height={200}>
          <BarChart data={barData}>
            <XAxis dataKey="name" />
            <YAxis allowDecimals={false} />
            <Tooltip content={<CustomTooltip />} />
            <Bar dataKey="count">
              {barData.map((entry, index) => (
                <Cell
                  key={`cell-${index}`}
                  fill={COLORS[index % COLORS.length]}
                />
              ))}
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      )}
    </div>
  );
};

export default UserGraph;
